import { render, staticRenderFns } from "./startPro.vue?vue&type=template&id=5053f740&scoped=true&"
import script from "./startPro.vue?vue&type=script&lang=js&"
export * from "./startPro.vue?vue&type=script&lang=js&"
import style0 from "./startPro.vue?vue&type=style&index=0&id=5053f740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5053f740",
  null
  
)

export default component.exports